module.exports = __webpack_public_path__ + "assets/3b.png";


//////////////////
// WEBPACK FOOTER
// ./images/3b.png
// module id = 698
// module chunks = 0